<form 
    (ngSubmit)="$event.preventDefault(); saveImmediateConcern();"
    [formGroup]="immediateConcernForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            With the input of all threat assessment team members, decide on a course of action and supervision plan. Please check all boxes that apply and will need detailed information in one or more Record of Assigned Responsibilities (ROAR) assignments. Not all steps will apply in every situation.
        </h2>
        <p class="font-semibold">Immediate Concerns and Safety Measures</p>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 

            <div *ngFor="let option of checkList" class="w-full flex flex-col gap-2">
                <label>
                    <div class="flex items-center">
                        <input [id]="option.formControlName" 
                        [formControlName]="option.formControlName"
                        (change)="onParentCheckboxChange($event, option.formControlName)"
                        type="checkbox"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500focus:ring-2">
                        <label [for]="option.formControlName" class="ms-2 font-semibold">
                            {{ option.label }}
                        </label>
                    </div>
                </label>
                <div *ngIf="immediateConcernForm.get(option.formControlName)?.value == yesNo.Yes">
                    <!-- check if here because ther're some questions don't have checkboxes dependencies, only textarea  -->
                    <p class="font-semibold pl-4" *ngIf="hasCheckboxDependencies(option.dependencies)">Select all that apply: *</p>
                    <div *ngFor="let dep of option.dependencies" class="pl-4 flex flex-col gap-2">
                        <div *ngIf="dep.type === 'checkbox'">
                            <input [id]="dep.formControlName" 
                            [formControlName]="dep.formControlName"
                            (change)="onDenpendencyCheckboxChange($event, option.formControlName, dep.formControlName)"
                            type="checkbox"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500focus:ring-2">
                            <label [for]="dep.formControlName" class="ms-2 font-semibold">
                                {{ dep.label }}
                            </label>
                        </div>
                        <div *ngIf="dep.type === 'textarea'" class="w-full flex flex-col items-center text-start">
                            <div class="w-full font-semibold">
                                <p>Planning Notes:</p>
                            </div>
                            <div class="w-full flex flex-col items-center">
                                <textarea [formControlName]="dep.formControlName"
                                            rows="3"
                                            class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                            placeholder="Type here..."></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Does this section require one or more assigned responsibilities to manage and support in the ROAR? *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="require_roar_yes" value="{{ yesNo.Yes }}" class="hidden peer"
                            formControlName="require_roar"
                        >
                        <label for="require_roar_yes"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="require_roar_no" value="{{ yesNo.No }}" class="hidden peer"
                            formControlName="require_roar"
                        >
                        <label for="require_roar_no"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.immediateConcernForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.immediateConcernForm.valid
                }"
                [disabled]="this.immediateConcernForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>